import { memoizeByAssetSource } from '@exodus/core-selectors/utils/memoize.js';
import { createSelector } from 'reselect';
import { getIncomingOrders } from './utils/incoming-orders.js';
export const getAssetSourceIncomingOrders = ({ orderSet, assetName, walletAccount, }) => getIncomingOrders({ orderSet, assetName, walletAccount });
export const selectorFactory = (ordersInProgressSelector) => memoizeByAssetSource(({ walletAccount, assetName }) => createSelector(ordersInProgressSelector, (orderSet) => getAssetSourceIncomingOrders({ orderSet, assetName, walletAccount })));
const createAssetSourceIncomingOrdersSelectorDefinition = {
    id: 'createAssetSourceIncomingOrders',
    selectorFactory,
    dependencies: [{ selector: 'ordersInProgress' }],
};
export default createAssetSourceIncomingOrdersSelectorDefinition;
